import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';

import { media } from 'context';
import { Layout, Modal, PillButton, Text, TextButton } from 'ds';
import { TENANT_ONBOARDING_CHECKLIST_PATH } from 'routes';
import { selectUser } from 'store/User/selectors';
import { useAppSelector } from 'store/hooks';

import { ReactComponent as PrepareForLaunchModal } from './PrepareForLaunchModal.svg';

import './OnboardingChecklistWelcomeModal.scss';

interface Props {
  isVisible: boolean;
  onClose: () => void;
  onSkip: () => void;
}

const OnboardingChecklistWelcomeModal: React.FC<Props> = ({ isVisible, onClose, onSkip }) => {
  const { isMobile } = useContext(media);
  const history = useHistory();
  const user = useAppSelector(selectUser);

  const handleViewChecklist = () => {
    history.push(TENANT_ONBOARDING_CHECKLIST_PATH);
    onClose();
  };

  return (
    <Modal
      isVisible={isVisible}
      onClose={onClose}
      width={isMobile ? undefined : 500}
      showCloseButton={false}
      closeOnClickOutside={false}
      paddingX={0}
      paddingTop={0}
      paddingBottom={0}
      isBottomSheet={isMobile}
      bottomSheetBorderRadius={isMobile ? 16 : undefined}
      bottomSheetIsRounded={isMobile}
      className={isMobile ? 'OnboardingChecklistWelcomeModal-mobile' : undefined}
    >
      <Layout
        direction="column"
        width="100%"
        style={{
          borderTopLeftRadius: 16,
          borderTopRightRadius: 16,
          overflow: 'hidden'
        }}
      >
        {/* Header with background image */}
        <Layout
          direction="column"
          align="center"
          justify="center"
          height={199}
          width="100%"
          position="relative"
          overflow="hidden"
          style={{
            borderTopLeftRadius: 16,
            borderTopRightRadius: 16
          }}
        >
          <img
            src="https://assets.codi.com/app_onboarding_checklist/PrepareForLaunchModalBG_QX-LXkLaN.png"
            alt=""
            style={{
              position: 'absolute',
              top: 0,
              left: 0,
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              objectPosition: 'center'
            }}
          />
          <Layout
            style={{
              position: 'absolute',
              inset: 0,
              backgroundColor: 'rgba(0, 0, 0, 0.08)',
              mixBlendMode: 'multiply'
            }}
          />
          <Layout
            direction="column"
            align="center"
            justify="center"
            position="relative"
            zIndex={1}
            width="100%"
            height="100%"
            style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}
          >
            <PrepareForLaunchModal />
          </Layout>
        </Layout>

        {/* Content */}
        <Layout direction="column" align="center" paddingX={60} paddingTop={32} paddingBottom={16} gap={16}>
          <Text size="headline-sm" color="gray-900" align="center">
            Welcome to Codi, {user?.firstname}!
          </Text>
          <Text size="body-md" color="gray-600" align="center">
            With everything your office needs in one place, getting settled has never been easier.
            <br />
            <br />
            Start by completing your office checklist.
          </Text>
        </Layout>

        {/* Footer */}
        <Layout direction="column" align="center" gap={24} paddingX={24} paddingTop={16} paddingBottom={24}>
          <PillButton
            type="purpleGradient"
            size="lg"
            text="View checklist"
            onClick={handleViewChecklist}
            fullWidth={isMobile}
          />
          <TextButton
            text="Skip"
            textSize="body-sm"
            color="gray-900"
            onClick={onSkip}
            paddingX={true}
            paddingY={false}
          />
        </Layout>
      </Layout>
    </Modal>
  );
};

export default OnboardingChecklistWelcomeModal;
